"use strict";
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileType = void 0;
/**
 * 文件类型
 */
var FileType;
(function (FileType) {
    FileType[FileType["OTHER"] = 0] = "OTHER";
    FileType[FileType["FOLDER"] = 1] = "FOLDER";
    FileType[FileType["IMAGE"] = 2] = "IMAGE";
    FileType[FileType["AUDIO"] = 3] = "AUDIO";
    FileType[FileType["VIDEO"] = 4] = "VIDEO";
    FileType[FileType["PDF"] = 5] = "PDF";
    FileType[FileType["OFFICE"] = 6] = "OFFICE";
    FileType[FileType["TXT"] = 7] = "TXT";
})(FileType = exports.FileType || (exports.FileType = {}));
